import { render, staticRenderFns } from "./PcNewsItem.vue?vue&type=template&id=11f6c983&scoped=true&"
import script from "./PcNewsItem.vue?vue&type=script&lang=js&"
export * from "./PcNewsItem.vue?vue&type=script&lang=js&"
import style0 from "./PcNewsItem.vue?vue&type=style&index=0&id=11f6c983&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11f6c983",
  null
  
)

export default component.exports